const FormWhats = function () {


    return {

        init : () => {

            $("#ico-whats").on("click", function(e){
                e.preventDefault();
                $("#modal-whats").fadeIn();
            });

        }

    }

}();

module.exports = FormWhats;